import { products } from './data.js'

export function resolveRoute(pathname) {
  const path = pathname.replace(/\/+$/, '') || '/'
  if (path === '/') return { page: 'home' }
  if (path === '/services') return { page: 'services' }
  if (path === '/overons') return { page: 'about' }
  if (path === '/offerte') return { page: 'quote' }
  if (path === '/thebottlingshop') return { page: 'shop' }
  if (path === '/av') return { page: 'legal' }
  if (path === '/aanleverspecificaties') return { page: 'specs' }
  if (path.startsWith('/items/')) {
    const product = products.find((item) => `/items/${item.slug}` === path)
    if (product) return { page: 'product', product }
  }
  return { page: 'notFound' }
}
